import { render } from "./App.vue?vue&type=template&id=06a8d9b4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=06a8d9b4&lang=scss"

import exportComponent from "/Users/kgeek/KGEEK/PERSONNAL/REMA/learning-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__